import 'rc-steps/assets/index.css'
import reactStringReplace from 'react-string-replace'
import { isEqual } from 'lodash'
import { PureComponent } from 'react'

import { translate } from '../../../utils/translation'
import { getUserTier, isPaidUser } from '../../../utils/freeVersionBlock'
import {
  kissmetricsRecordingEvent,
  KISSMETRICS_TRACK_EVENTS,
} from '../../../utils/kissmetrics'
import { Text } from '../../../components/topography'
import { fonts, palette } from '../../../styles/variables'
import { generateRegExp } from '../../../utils/functions'
import { LinkButton } from '../../../components/buttons/Buttons'
import { getUserFreeTrialDays, isSubUser } from '../../../utils/userAuth'

import DashboardAddKeywordsController from './AddKeywordsPanel'
import { StepWrapper, NavButtons, NavButton, StepContent } from './styled'

export default class Step3 extends PureComponent {
  constructor(props) {
    super(props)

    const { locations } = this.props

    this.state = {
      locations,
      selectedLocations: locations,
      invalidKeywords: false,
      invalidLocations: false,
    }
  }

  static getDerivedStateFromProps(nextProps, prevState) {
    if (!isEqual(prevState.locations, nextProps.locations)) {
      return {
        locations: nextProps.locations,
        selectedLocations: nextProps.locations,
        invalidKeywords:
          nextProps.keywords.length * nextProps.locations.length >
          nextProps.MAX_KEYWORDS_PER_PROJECT,
        invalidLocations:
          nextProps.locations.length === 0 ||
          nextProps.locations.length >
            nextProps.MAX_COMPETITORS_LOCATIONS_PER_PROJECT,
      }
    }
    return {
      invalidKeywords:
        nextProps.keywords.length * nextProps.locations.length >
        nextProps.MAX_KEYWORDS_PER_PROJECT,
    }
  }

  // setKeywords is unsafe, check limits here so that AddKeywordsController handles most of the logic
  setNewKeywords = (newKeywords) => {
    const { selectedLocations } = this.state
    const filtered = Array.from(new Set(newKeywords))

    const totalCount = filtered.length * selectedLocations.length
    const { MAX_KEYWORDS_PER_PROJECT } = this.props
    if (totalCount > MAX_KEYWORDS_PER_PROJECT) {
      if (filtered.length > this.props.keywords.length)
        this.props.showUpgradeModal('step3_reached_maximum_keyword')
    }
    this.props.setKeywords(filtered)
    this.setState({ invalidKeywords: totalCount > MAX_KEYWORDS_PER_PROJECT })
  }

  setLocations = (locations) => {
    const totalCount = this.props.keywords.length * locations.length
    const { MAX_KEYWORDS_PER_PROJECT } = this.props
    this.setState({
      invalidKeywords: totalCount > MAX_KEYWORDS_PER_PROJECT,
      invalidLocations: !locations.length,
      selectedLocations: locations,
    })
  }

  render() {
    const {
      availableKeywords,
      nextStep,
      onSubmit,
      previousStep,
      keywords,
      locations,
      newAddonProject,
      MAX_KEYWORDS_PER_PROJECT,
      openEditLocationsModal,
      showUpgradeModal,
    } = this.props
    const { invalidKeywords, selectedLocations, invalidLocations } = this.state
    const ctaText = isPaidUser()
      ? translate('upgrade_your_plan')
      : translate('start_free_trial_button', getUserFreeTrialDays())
    const kwCount = MAX_KEYWORDS_PER_PROJECT
    const upgradeText =
      getUserTier() === 'tier3'
        ? translate('can_track_up_to_kw', kwCount)
        : translate('cta_to_track_more_kw', ctaText, kwCount)
    const listRegExp = generateRegExp([ctaText, `<b>${kwCount}</b>`])
    const isSubUserAccount = isSubUser()

    return (
      <StepWrapper width="100%">
        <StepContent>
          <DashboardAddKeywordsController
            testId="testId"
            keywordsInProject={[]}
            locations={locations}
            availableKeywords={availableKeywords}
            kwsToAdd={keywords}
            setKwsToAdd={this.setNewKeywords}
            selectedLocations={selectedLocations}
            setSelectedLocations={this.setLocations}
            areLocationsInvalid={invalidLocations}
            areKeywordsInvalid={invalidKeywords}
            newAddonProject={newAddonProject}
            openEditLocationsModal={openEditLocationsModal}
          />
          <Text
            lineHeight="22px"
            boldColor={palette.darkGray}
            textAlign="center"
            margin="16px 0 0 0"
          >
            {reactStringReplace(upgradeText, listRegExp, (match, index) => {
              if (match.startsWith('<b>')) {
                return <b key={index}>{kwCount}</b>
              }
              return (
                <LinkButton
                  key={index}
                  onClick={() => showUpgradeModal(null)}
                  disabled={isSubUserAccount}
                  style={{
                    textDecoration: 'underline',
                    fontSize: '14px',
                    margin: '0px',
                    display: 'inline-block',
                    fontFamily: fonts.primaryBook,
                    paddingLeft: 0,
                    paddingRight: 0,
                  }}
                >
                  {ctaText}
                </LinkButton>
              )
            })}
          </Text>
        </StepContent>
        <NavButtons>
          <NavButton
            testId="add-project-step3-close"
            color="grey"
            onClick={previousStep}
            tag={translate('back')}
          />
          <NavButton
            testId="add-project-step3-skip"
            color="grey"
            onClick={(event) => {
              kissmetricsRecordingEvent(
                KISSMETRICS_TRACK_EVENTS.project_creation_actions,
                {
                  'project flow action': 'keywords add skip',
                },
              )

              nextStep(event)
              onSubmit(selectedLocations, true)
            }}
            tag={translate('skip')}
          />
          <NavButton
            testId="add-project-step3-next"
            color="orange"
            onClick={(event) => {
              if (keywords.length === 0) {
                return
              }

              if (!invalidKeywords && !invalidLocations) {
                kissmetricsRecordingEvent(
                  KISSMETRICS_TRACK_EVENTS.project_creation_actions,
                  {
                    'project flow action': 'keyword add next',
                  },
                )
                nextStep(event)
                onSubmit(selectedLocations)

                return
              }
              if (invalidKeywords) {
                showUpgradeModal('step3_reached_maximum_keyword')
              }
            }}
            tag={translate('next')}
            disabled={
              invalidKeywords || invalidLocations || keywords.length === 0
            }
          />
        </NavButtons>
      </StepWrapper>
    )
  }
}
